var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconLogoFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 33,
  height: 26,
  viewBox: "0 0 33 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 25.4746H32.3604V0.500244H0V25.4746Z",
  fill: "#FEFEFE"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.79176 22.6787H14.7779V3.29352H2.79176V22.6787Z",
  fill: "#FFCA05"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.5824 22.6787H29.5686V3.29352H17.5824V22.6787Z",
  fill: "#001246"
})));
export default SvgIconLogoFlag;